import React, { useEffect, useState } from "react";
import "../../../../../css/Form.css";
// import Select from 'react-select';
// import ImagesPopup from '../../../../../helper/ImagesPopup';
import UploadFile from "../../../../../helper/UploadFile";
import ApiGateway from "../../../../../helper/ApiGateway";
import Utils from "../../../../../helper/Utils";

const AddtionalTenthDetails = (props) => {
  const {
    // Tenth,
    countries,
    states,
    // EducationSelectHandler,
    interviewDetails,
    // onFileChange,
    // openImageInTab,
    // imageRemoveHandler,
    // dataForDocsView,
    SelectedFormState,
    setSelectedFormState,
    // RequiredFields
    // selectedRoundData,
  } = props;

  // const [openView, setOpenView] = useState({
  // 	popupOpen: false,
  // 	currentIndex: null
  // });

  const getUploadData = (data, index) => {
    let newState = { ...SelectedFormState };
    newState.AdditonalEducationDetails.qualificationList[index].documentList = data;
    setSelectedFormState(newState);
  };

  const [uploadProcessCode] = useState([
    "EMPLOYEE_APP_EDN_CLASSX",
    "EMPLOYEE_APP_EDN_CLASSXII",
    "EMPLOYEE_APP_EDN_UG",
    "EMPLOYEE_APP_EDN_PG",
    "EMPLOYEE_APP_EDN_MPHIL",
    "EMPLOYEE_APP_EDN_DIPLOMA",
    "EMPLOYEE_APP_EDN_PHD",
    "EMPLOYEE_APP_EDN_OTHERS",
    "EMPLOYEE_APP_EDN_ELIGIBILITY_TEST",
    "EMPLOYEE_APP_PROFESSIONAL_EXP",
    "EMPLOYEE_APP_PHOTO",
  ]);

  const [UploadData, setUploadData] = useState([]);

  const getData = () => {
    ApiGateway.getBuilder()
      .addPost(`Common/getFolderListForMenu?processCode=${[...uploadProcessCode]}`, {})
      .execute((responses) => {
        try {
          let UploadData = [];
          if (Utils.isUndefinedOrNull(responses) === false && Utils.isUndefinedOrNull(responses.length) === false) {
            UploadData = responses[0].data || [];
            setUploadData(Utils.isUndefinedOrNull(UploadData) === false ? UploadData : []);
          }
        } catch (ex) {}
      });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formateType = UploadData.filter((item) => item.uploadProcessCode);

  return (
    <div>
      <div style={{ overflow: "auto" }} className="table table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>
                <label>Qualification</label>
              </th>
              <th>
                <label>Status</label>
              </th>
              <th>
                <label>Course</label>
              </th>
              <th>
                <label>Specialization</label>
              </th>
              {/* <th>
                <label>Current Status</label>
              </th> */}
              <th >
                <label style={{width:"150px"}}>Grade/ Percentage/ Current Status </label>
              </th>
              <th>
                <label>Institute</label>
              </th>
              <th>
                <label>Board/University</label>
              </th>
              <th>
                <label>State</label>
              </th>
              <th>
                <label>Country</label>
              </th>

              <th>
                <label>Year of Completion</label>
              </th>
              <th>
                <label>Year of Registration</label>
              </th>
              <th style={{ width: "" }}>
                <label>Document </label>
                <br />
                <span className="upload-accepted-format-indication">({formateType[0]?.fileTypeList.join(",")})</span>
                {/* <span style={{ fontSize: "11px", color: "GrayText" }}>
                      <em>
                        {" "}
                        <b>(Pdf,Image)</b>
                      </em>
                    </span> */}
                    <br/>
												<span className='upload-accepted-format-indication'>File size limit: less than 1024kb</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {SelectedFormState?.AdditonalEducationDetails?.qualificationList
              .sort((a, b) => parseInt(a?.qualificationLevelDegreeOrder) - parseInt(b?.qualificationLevelDegreeOrder))
              .map((els, index) => {
                let processCode;
                const upProccedCode = "EMPLOYEE_APP_EDN_" + els.qualificationLevelCode;
                processCode = upProccedCode;
                const processCodeData = UploadData.filter((item) => item.uploadProcessCode === processCode);
                return (
                  <tr key={index}>
                    <td>
                      <label style={{ fontSize: "0.9rem" }}>{els.qualificationName || "NA"}</label>
                    </td>

                    <td>
                      <label style={{ fontSize: "0.9rem" }}>{els.currentStatus==="1"?"Pursuing":els.currentStatus==="2"?"Completed":"NA" }</label>
                    </td>

                    <td>
                      <label style={{ fontSize: "0.9rem" }}>{els.course || "NA"}</label>
                    </td>

                    <td>
                      <label style={{ fontSize: "0.9rem" }}>{els.specialization || "NA"}</label>
                    </td>

                    {/* <td>{els.currentStatus?.label === "Pursuing" ? <label style={{ fontSize: "0.9rem" }}>{els.gradeOrPercentage || "NA"}</label> : "NA"}</td> */}

                    <td>
                      <label style={{ fontSize: "0.9rem" }}>{els.gradeOrPercentage || "NA"}</label>
                    </td>

                    <td>
                      <label style={{ fontSize: "0.9rem" }}>{els.institute || "NA"}</label>
                    </td>

                    <td>
                      <label style={{ fontSize: "0.9rem" }}>{els.boardOrUniversity || "NA"}</label>
                    </td>

                    <td>
                      <label style={{ fontSize: "0.9rem" }}>
                        {!Utils.isNullorWhiteSpace(els.stateId)
                          ? Utils.getSelect2ItemByID(states, els?.stateId)?.label
                          : !Utils.isNullorWhiteSpace(els.stateOther)
                          ? els.stateOther
                          : "NA"}
                      </label>
                    </td>

                    <td>
                      <label style={{ fontSize: "0.9rem" }}>
                        {!Utils.isNullorWhiteSpace(els?.countryId) ? Utils.getSelect2ItemByID(countries, els?.countryId)?.label : "NA"}
                      </label>
                    </td>

                    <td>
                      <label style={{ fontSize: "0.9rem" }}>{els.currentStatus === "2" || els.currentStatus === null ? els.yearOfCompletion : "NA"}</label>
                    </td>

                    {/****Year of registration */}
                    <td>{els.currentStatus === "1" ? <label style={{ fontSize: "0.9rem" }}>{els.yearOfCompletion || "NA"}</label> : "NA"}</td>
                    <td>
                      <UploadFile 
                      callback={(e) => getUploadData(e, index)} 
                      data={els.documentList} 
                      isMulti 
                      keyList={processCodeData} 
                      id={processCode} 
                      isViewOnly
                      />
                    </td>
                  </tr>
                );
              })}
            {SelectedFormState.AdditonalEducationDetails.others.length > 0
              ? SelectedFormState.AdditonalEducationDetails.others.map((others, index) => {
                // let processCode;
                // const upProccedCode = "EMPLOYEE_APP_EDN_" + others.qualificationLevelCode;
                // processCode = upProccedCode;
                // const processCodeData = UploadData.filter((item) => item.uploadProcessCode === processCode);
              
              return(
                  <tr key={index}>
                    <td style={{ fontSize: "0.9rem" }}>
                      <label className="">{others.qualificationOthers || "NA"}</label>
                    </td>
                    <td style={{ fontSize: "0.9rem" }}>
                       <label style={{ fontSize: "0.9rem" }}>{others.currentStatus==="1"?"Pursuing":others.currentStatus==="2"?"Completed":"NA" }</label>
                    </td>
                    <td style={{ fontSize: "0.9rem" }}>
                      <label className="">{others.course || "NA"}</label>
                    </td>
                    <td style={{ fontSize: "0.9rem" }}>
                      <label className="">{others.specialization || "NA"}</label>
                    </td>
                    {/* <td>{others.currentStatus?.label === "Pursuing" ? <label style={{ fontSize: "0.9rem" }}>{others.gradeOrPercentage || "NA"}</label> : "NA"}</td> */}

                    <td style={{ fontSize: "0.9rem" }}>
                      <label className="">{others.gradeOrPercentage || "NA"}</label>
                    </td>
                   
                    <td style={{ fontSize: "0.9rem" }}>
                      <label className="">{others.institute || "NA"}</label>
                    </td>
                    <td style={{ fontSize: "0.9rem" }}>
                      <label className="">{others.boardOrUniversity || "NA"}</label>
                    </td>
                    <td>
                      <label style={{ fontSize: "0.9rem" }}>
                        {!Utils.isNullorWhiteSpace(others.stateId)
                          ? Utils.getSelect2ItemByID(states, others?.stateId)?.label
                          : !Utils.isNullorWhiteSpace(others.stateOther)
                          ? others.stateOther
                          : "NA"}
                      </label>
                    </td>
                    <td>
                      <label style={{ fontSize: "0.9rem" }}>
                        {!Utils.isNullorWhiteSpace(others?.countryId) ? Utils.getSelect2ItemByID(countries, others?.countryId)?.label : "NA"}
                      </label>
                    </td>
                    <td>
                       <label style={{ fontSize: "0.9rem" }}>{others?.currentStatus === "2" || others?.currentStatus === null ? others?.yearOfCompletion : "NA"}</label>
                    </td>
                    <td>{others?.currentStatus === "1" ? <label style={{ fontSize: "0.9rem" }}>{others?.yearOfCompletion || "NA"}</label> : "NA"}</td>

                    <td>
                    {/* <UploadFile  callback={(e) => getUploadData(e, index)} data={others.documentList} isMulti keyList={processCodeData} id={processCode} /> */}
                    </td>
                  </tr>
                )
              })
              : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddtionalTenthDetails;
